import React from 'react';

var ThemeName = React.createClass({
    getInitialState: function(){
        return {windowWidth: document.body.clientWidth, title: ""}
    },
    componentDidMount : function() {
        window.addEventListener('resize', this.handleResize);
    },
    componentWillReceiveProps: function(nextProps){
        this.setState({title: nextProps.themeName});
    },
    componentWillUnmount: function() {
        window.removeEventListener('resize', this.handleResize);
    },
    handleResize: function(e){
        this.setState({windowWidth: document.body.clientWidth});
        if(this.state.windowWidth < 1220)
        {
            if(this.props.themeName.length > 15){
                var new_title =  (this.props.themeName).slice(0,15)+"... " ;
            } else {
                var new_title = this.props.themeName;
            }
            this.setState({title: new_title})
        }
        else{
            this.setState({title: this.props.themeName});
        }
    },
	render: function(){
		return(
			<li className="page__title">
				<a>
					<span className = "small__title">{this.state.title} </span>
					<strong className="tool--tip">{this.props.themeName} </strong>
				</a>
			</li>
		);
	}
});

export {ThemeName};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/ThemeName.jsx
 **/